import { useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { DataCard } from '@/components/card'
import { FilterableTable } from '@/components/table/base'
import { STORE_STATUS } from '@/constants/store'
import { streamingRestApi } from '@/service/streamingApi'
import { useLowLatencyHostsStore } from '@/stores/lowLatencyHosts'

import { OpenDialogButton } from '../ConsoleDialog/handlers'
import AddLowLatencyHostsForm from '../forms/AddLowLatencyHostsForm/AddLowLatencyHostsForm'
import { ActionsMenu } from '../table/actions'
import { ActionDeleteLowLatencyHostItem } from '../table/actions/ActionDeleteLowLatencyHostItem/ActionDeleteLowLatencyHostItem'
import {
  LOW_LATENCY_HOSTS_DGE_TABLE_COLUMNS,
  LOW_LATENCY_HOSTS_FILTERS
} from './lowLatencyHosts.dge.table'

const tableId = 'low-latency-hosts'

const LowLatencyHosts = () => {
  const { data, isLoading, fetchData, resetState } = useLowLatencyHostsStore(
    useShallow((state) => ({
      data: state.data,
      selectedFilters: state.filters,
      isLoading: state.status === STORE_STATUS.loading,
      fetchData: state.fetchData,
      setFilters: state.setFilters,
      resetState: state.resetState,
      filters: state.filters
    }))
  )

  useEffect(() => {
    fetchData()
    return resetState
  }, [fetchData, resetState])

  const handleDeleteHost = async (hostId: number) => {
    await streamingRestApi.endpoints.lowLatencyHosts.deleteLowLatencyHost(hostId)
    await fetchData()
  }

  return (
    <DataCard
      title="Low Latency Hosts"
      headerPostfixActions={
        <OpenDialogButton label="Add Host">
          <AddLowLatencyHostsForm onSubmit={fetchData} />
        </OpenDialogButton>
      }
    >
      <FilterableTable
        tableId={tableId}
        data={data}
        loading={isLoading}
        columns={LOW_LATENCY_HOSTS_DGE_TABLE_COLUMNS}
        clientSideSortAndPagination
        clientSideFilters
        filters={LOW_LATENCY_HOSTS_FILTERS}
        rowActions={
          <ActionsMenu>
            <ActionDeleteLowLatencyHostItem onDelete={handleDeleteHost} />
          </ActionsMenu>
        }
      />
    </DataCard>
  )
}

export default LowLatencyHosts
